export const PREDEFINED_SCHEDULES = [
  {
    code: "FF",
    legend: "FF",
    description: "Off Day",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Off",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Off" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "HF",
    legend: "HF",
    description: "HF",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Off",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Off" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "XX",
    legend: "XX",
    description: "XX",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Off",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Off" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "YY",
    legend: "YY",
    description: "YY",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Off",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Off" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "FE",
    legend: "FE",
    description: "Vacation Day",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Vacation",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Vac" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "FR",
    legend: "FR",
    description: "Holiday",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Holiday",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Ho" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "Abs",
    legend: "Abs",
    description: "Absence",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Absence",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Abs" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  },
  {
    code: "Cmp",
    legend: "Cmp",
    description: "Cmp",
    startDay: "Today",
    endDay: "Today",
    startTime: "",
    endTime: "",
    weightTime: "0",
    schedule_type: "Comp",
    mealBreaks: [{
      enabled: false,
      startTime: "",
      endTime: ""
    }],
    shiftTypes: [
      { active: true, type: "Comp" },
      { active: false, type: '' },
      { active: false, type: '' },
      { active: false, type: '' }
    ]
  }
];

export const isPredefinedSchedule = (code) => {
  return PREDEFINED_SCHEDULES.some(schedule => schedule.code === code);
};


export const initializePredefinedSchedules = () => {
  const savedSchedules = JSON.parse(sessionStorage.getItem('schedules') || '[]');
  const predefinedCodes = PREDEFINED_SCHEDULES.map(s => s.code);
  
  const userSchedules = savedSchedules.filter(s => !predefinedCodes.includes(s.code));
  
  let combinedSchedules;
  if (savedSchedules.length > 0) {
    combinedSchedules = [...savedSchedules];
    
    PREDEFINED_SCHEDULES.forEach(predefined => {
      if (!combinedSchedules.some(s => s.code === predefined.code)) {
        combinedSchedules.push(predefined);
      }
    });
  } else {
    combinedSchedules = [...PREDEFINED_SCHEDULES, ...userSchedules];
  }
  
  sessionStorage.setItem('schedules', JSON.stringify(combinedSchedules));
  return combinedSchedules;
};

export const formatTime = (time) => {
  if (!time) return '-';
  const [hours, minutes] = time.split(':').map(Number);

  if (minutes === 0) {
    return hours.toString();
  }

  if (minutes % 30 === 0) {
    return minutes === 30 ? `${hours},5` : hours.toString();
  }

  const decimalPart = minutes / 60;
  const formattedDecimal = (decimalPart * 100).toFixed(0);
  
  if (minutes === 15) return `${hours},25`;
  if (minutes === 45) return `${hours},75`;

  return `${hours},${formattedDecimal}`;
};

export const calculateWeightTime = (schedule) => {
  
  if (!schedule.startTime || !schedule.endTime) return '';
  
  const startMinutes = convertTimeToMinutes(schedule.startTime, schedule.startDay);
  const endMinutes = convertTimeToMinutes(schedule.endTime, schedule.endDay);
  
  let totalMinutes = endMinutes - startMinutes;
  
  const mealBreak = schedule.mealBreaks[0];
  if (mealBreak?.enabled && mealBreak.startTime && mealBreak.endTime) {
    const mealStartMinutes = convertTimeToMinutes(mealBreak.startTime, schedule.startDay);
    const mealEndMinutes = convertTimeToMinutes(mealBreak.endTime, schedule.startDay);
    totalMinutes -= (mealEndMinutes - mealStartMinutes);
  }
  
  const hours = totalMinutes / 60;
  
  return hours.toString();
};

export const formatScheduleType = (shiftType) => {
  return ['M', 'T', 'N'].includes(shiftType) ? 'W' : shiftType;
};

export const formatWeight = (weight) => {
  const numWeight = parseFloat(weight);
  if (isNaN(numWeight)) return '0';
  if (numWeight >= 10) return '100';
  return Math.floor(numWeight * 10).toString();
};

export const formatShiftTypes = (shiftTypes) => {
  const activeShifts = shiftTypes
      .filter(shift => shift.active && shift.type)
      .map(shift => shift.type)
      .sort();

  if (activeShifts.every(type => ['M', 'T', 'N'].includes(type))) {
      return activeShifts.join('');
  }

  return activeShifts[0] || '';
};

export const initialScheduleState = {
    code: '',
    legend: '',
    schedule_type: '',
    description: '',
    startDay: 'Today',
    endDay: 'Today',
    startTime: '',
    endTime: '',
    weightTime: '',
    mealBreaks: [
        {
        enabled: false,
        startTime: '',
        endTime: '',
        }
    ],
    shiftTypes: [
        { active: false, type: '' },
        { active: false, type: '' },
        { active: false, type: '' },
        { active: false, type: '' }
    ],
};


export const ensureScheduleStructure = (schedule) => {

const existingShiftTypes = schedule.shiftTypes || [];

const fullShiftTypes = Array(4).fill(null).map((_,index) => ({
    active:false,
    type:"",
    ...existingShiftTypes[index]
}));

return {
    ...schedule,
    mealBreaks: (schedule.mealBreaks || []).map(break_ => ({
    enabled: false,
    startTime: "",
    endTime: "",
    ...break_
    })),
    shiftTypes: fullShiftTypes
};
};

export const isTimeValid = (time) => {
  if (!time) return {
    isValid: false,
    error: {
      title: 'Time Error',
      description: 'Time is required',
      variant: 'destructive'
    }
  };
  
  if (!/^\d{1,2}:\d{2}$/.test(time)) return {
    isValid: false,
    error: {
      title: 'Time Error',
      description: 'Time must be in HH:MM format',
      variant: 'destructive'
    }
  };
  
  const [hours, minutes] = time.split(':').map(Number);
  
  const isValid = (hours === 24 && minutes === 0) || 
                 (hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60);
                 
  if (!isValid) {
    return {
      isValid: false,
      error: {
        title: 'Time Error',
        description: 'The time must be between 0:00 and 24:00',
        variant: 'destructive'
      }
    };
  }
  
  return { isValid: true };
};

export const convertTimeToMinutes = (time, day) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(':').map(Number);
  let totalMinutes = hours * 60 + minutes;
  
  let dayOffset = 0;
  if (day === 'Yesterday') dayOffset = -1;
  else if (day === 'Tomorrow') dayOffset = 1;
  
  return totalMinutes + (dayOffset * 24 * 60);
};


export const isNormalShift = (type) => {
    return ['M', 'T', 'N'].includes(type);
};

export const validateScheduleTimes = (schedule, t) => {
  const startTimeValidation = isTimeValid(schedule.startTime);
  if (!startTimeValidation.isValid) return startTimeValidation;

  const endTimeValidation = isTimeValid(schedule.endTime);
  if (!endTimeValidation.isValid) return endTimeValidation;

  const startTimeMinutes = convertTimeToMinutes(schedule.startTime, schedule.startDay);
  const endTimeMinutes = convertTimeToMinutes(schedule.endTime, schedule.endDay);
  
  if (endTimeMinutes <= startTimeMinutes) {
    return {
      isValid: false,
      error: {
        title: t('alert.error.time'),
        description: t('alert.error.time.endAfterStart'),
        variant: 'destructive'
      }
    };
  }

  const enabledMealBreak = schedule.mealBreaks.find(break_ => break_.enabled);
  if (enabledMealBreak) {
    const mealStartValidation = isTimeValid(enabledMealBreak.startTime);
    if (!mealStartValidation.isValid) return {
      isValid: false, 
      error: {
        title: t('alert.error.mealTime'),
        description: t('alert.error.mealTime.validStart'),
        variant: 'destructive'
      }
    };

    const mealEndValidation = isTimeValid(enabledMealBreak.endTime);
    if (!mealEndValidation.isValid) return {
      isValid: false,
      error: {
        title: t('alert.error.mealTime'),
        description: t('alert.error.mealTime.validEnd'),
        variant: 'destructive'
      }
    };

    const mealStartMinutes = convertTimeToMinutes(enabledMealBreak.startTime, schedule.startDay);
    const mealEndMinutes = convertTimeToMinutes(enabledMealBreak.endTime, schedule.startDay);

    if (mealStartMinutes < startTimeMinutes || mealEndMinutes > endTimeMinutes) {
      return {
        isValid: false,
        error: {
          title: t('alert.error.mealTime'),
          description: t('alert.error.mealTime.between'),
          variant: 'destructive'
        }
      };
    }

    if (mealEndMinutes <= mealStartMinutes) {
      return {
        isValid: false,
        error: {
          title: t('alert.error.mealTime'),
          description: t('alert.error.mealTime.endAfterStart'),
          variant: 'destructive'
        }
      };
    }
  }

  return { isValid: true };
};


export const shouldDisableTimeInputs = (schedule) => {
    if (!schedule || !schedule.shiftTypes) return false;

    const activeShifts = schedule.shiftTypes.filter(shift => shift.active && shift.type);
    if (activeShifts.length === 0) return false;

    return activeShifts.some(shift => !isNormalShift(shift.type));
};


export const generateScheduleCode = (shiftTypes, weightTime) => {
    const activeShifts = shiftTypes.filter(shift => shift.active && shift.type);
    
    if (activeShifts.length === 0) return '';
  
    const specialCodes = {
      'Off': 'FF',
      'Vac': 'FE',
      'Ho': 'FR',
      'Abs': 'ABS',
      'Comp': 'Cmp'
    };
  
    const firstShift = activeShifts[0].type;
    if (firstShift in specialCodes) {
      return specialCodes[firstShift];
    }
  
    const normalShifts = activeShifts.filter(shift => ['M', 'T', 'N'].includes(shift.type));
    
    if (normalShifts.length === 0) return '';
    
    if (normalShifts.length === 1) {
      return `${normalShifts[0].type}${weightTime}`;
    } else {
      return `I${weightTime}`;
    }
  };


export const generateLegend = (schedule) => {
    const { startTime, endTime, mealBreaks, shiftTypes } = schedule;

    const activeShift = shiftTypes.find(shift => shift.active && shift.type);

    if(activeShift && ['Off','Vac', 'Ho', 'Abs', 'Comp'].includes(activeShift.type)){
        const specialCodes = {
            'Off': 'FF',
            'Vac': 'FE',
            'Ho': 'FR',
            'Abs': 'ABS',
            'Comp': 'Cmp'
        };

        return specialCodes[activeShift.type];
    };

    if(!startTime || !endTime) return '';

    

    const mealBreak = mealBreaks.find(break_ => break_.enabled);
    if (mealBreak && mealBreak.startTime && mealBreak.endTime) {
        return `${startTime}-${mealBreak.startTime}-${mealBreak.endTime}-${endTime}`;
    }

    return `${startTime}-${endTime}`;
}

